import React from "react";
import { useNavigate } from "react-router-dom";

const GroupAccountBanner = ({ onClick, className = "" }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate("/group-account");
    }
  };

  return (
    <div
      onClick={handleClick}
      className={`p-5 rounded-2xl bg-black text-white border-2 border-black shadow-md flex items-start gap-4 cursor-pointer hover:opacity-95 transition-all duration-200 active:scale-[0.99] ${className}`}
    >
      <div className="w-12 h-12 rounded-xl bg-green-500 flex items-center justify-center flex-shrink-0 text-white font-bold text-2xl">
        👥
      </div>
      <div className="flex-1">
        <h3 className="text-2xl font-bold text-white mb-1">
          Start a Group Account - Save Together. Spend Together. Win Together.
        </h3>
        <p className="text-xl text-gray-300">
          A shared wallet built for families, friends, offices, church units, and groups.
        </p>
      </div>
    </div>
  );
};

export default GroupAccountBanner;
